import * as React from 'react';
import { ArticleHeading1, ArticleHeading2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import * as style from './style.css';

interface IInfrastructureLayoutProps {
  isDesktop: boolean;
  metroAndRoads: React.ReactNode;
  children: React.ReactNode;
}

export const InfrastructureLayout: React.FC<IInfrastructureLayoutProps> = ({
  isDesktop = true,
  metroAndRoads,
  children,
}) => {
  return (
    <div data-testid="Infrastructure" className={style['container']}>
      <div className={style['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
          Инфраструктура
        </ConditionalWrapper>
      </div>

      {metroAndRoads}
      <div className={style['wrapper']}>{children}</div>
    </div>
  );
};
